import { useContext } from 'react';
import { AppContext } from './Context';

const useAppProvider = () => {
  const appContext = useContext(AppContext);
  const {
    configVariables: { courseStatic = '', coursesStatic = '', employeeStatic = '', employeesStatic = '' },
    theme,
    setProviderState,
  } = appContext;

  const {
    appTheme,
    themeConfigId,
    sidebarColor,
    sidebarLabelColor,
    activeItemColor,
    activeItemLabelColor,
    buttonColor,
    buttonBorderColor,
    buttonLabelColor,
    activeTabColor,
    activeTabBorderColor,
    shadowOnActive,
    tableHeadersColor,
  } = theme;

  return {
    // Course/Employee Labels
    courseStatic,
    coursesStatic,
    employeeStatic,
    employeesStatic,
    // Theme
    theme, // Whole theme data
    // Theme: Sidbar
    appTheme,
    themeConfigId,
    sidebarColor,
    sidebarLabelColor,
    activeItemColor,
    activeItemLabelColor,
    // Theme: Button/Tab
    buttonColor,
    buttonBorderColor,
    buttonLabelColor,
    activeTabColor,
    activeTabBorderColor,
    // Theme: Common
    shadowOnActive,
    tableHeadersColor,

    // Updater
    setProviderState,
  };
};

export default useAppProvider;
